export default "__VITE_ASSET__efd1576a__"